import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DialogSettings } from '../../types/confirm';

export interface ConfirmSlice {
  dialogState: DialogSettings;
  open: boolean;
}

export const defaultDialogState: ConfirmSlice = {
  dialogState: {
    title: 'Are you sure ?',
    description: 'Do you really wanna do this action ?',
    cancelButtonText: 'No',
    confirmButtonText: 'Yes',
  },
  open: false,
};

export const filterSlice = createSlice({
  name: 'filter',
  initialState: defaultDialogState,
  reducers: {
    setDialogOpen: (state, action: PayloadAction<boolean>) => {
      state.open = action.payload;
    },
    setDefaultDialogSettings: (state, _: PayloadAction<undefined>) => {
      state.dialogState = defaultDialogState.dialogState;
    },
    setCurrentDialogSettings: (state, action: PayloadAction<DialogSettings>) => {
      state.dialogState = action.payload;
    },
  },
});

export const { setDialogOpen, setDefaultDialogSettings, setCurrentDialogSettings } = filterSlice.actions;
export default filterSlice.reducer;
